import { render } from "./WelcomeMedicalReports.vue?vue&type=template&id=88cb0920&scoped=true"
import script from "./WelcomeMedicalReports.vue?vue&type=script&lang=js"
export * from "./WelcomeMedicalReports.vue?vue&type=script&lang=js"

import "./WelcomeMedicalReports.vue?vue&type=style&index=0&id=88cb0920&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88cb0920"]])

export default __exports__